export default[
    {
        path: '/vale/transporte/trabalhador/cadastro/:trabalhador_id',
        name: 'cadastro do vale transporte', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/vale/transporte/trabalhador/lista',
        name: 'lista do vale transporte', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/vale/transporte/trabalhador/editar/:id/:trabalhador_id',
        name: 'editar vale transporte', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]